export default "__VITE_ASSET__GFXGUJAm__"